module.exports = __webpack_public_path__ + "img/translate.54a89f6b.png";